import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const ContactImageAnimation = () => {
  const containers = document.querySelectorAll(".contact-image");
  if (containers.length < 1) {
    return;
  }

  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  if (reduceMotion) return;

  const base = {
    y: 0,
    opacity: 1,
    duration: 1,
    ease: "power2.inOut",
  };
  const applyAnimations = () => {
    containers.forEach((container) => {
      const headline = container.querySelectorAll(".contact-image__headline");
      const subline = container.querySelectorAll(".contact-image__subline");
      const image = container.querySelectorAll(".contact-image__image");
      const form = container.querySelectorAll(".contact-image__text-container");

      if (!headline.length && !subline.length && !image.length && !form.length)
        return;

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container,
          start: "top 80%",
          once: true,
          fastScrollEnd: true,
        },
      });

      if (headline.length) {
        tl.to(headline, { ...base, x: 0 });
      }

      if (subline.length) {
        tl.to(subline, { ...base, x: 0 });
      }

      if (form.length) {
        tl.to(
          form,
          {
            ...base,
            x: 0,
          },
          "-=1",
        );
      }

      if (image.length) {
        tl.to(
          image,
          {
            opacity: 1,
            duration: 1,
            ease: "back.out(1.7, 0.5)",
            scale: 1,
          },
          "-=0.3",
        );
      }
    });
  };
  applyAnimations();
};

export default ContactImageAnimation;
